import React, { forwardRef, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Radio,
  Upload,
  Button,
  Spin,
} from "antd";
import { EditableProTable } from "@ant-design/pro-components";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import API from "@/api";
import { v4 as uuidv4 } from "uuid";
import "./index.less";

function ZntsqFormDetail(props, ref) {
  const formRef = useRef();
  const { type, select, zntTypes, orgs, selectedRow, departments, userInfo } =
    props;
  const [orgsData, setOrgs] = useState(orgs);
  const [orgId, setOrgId] = useState("");
  const [orgName, setOrgName] = useState("");
  const [fileList, setFileList] = useState([]);

  const [showApi, setShowApi] = useState(false); //API密钥
  const [showUrl, setShowUrl] = useState(false); //基础url
  const [showJrdz, setShowJrdz] = useState(false); //接入地址
  const [shwoOpen, setShowOpen] = useState(false); // 打开方式

  const [showDep, setShowDep] = useState(false);

  const [dataSource, setDataSource] = useState([]);
  const [webData, setWebData] = useState([]);

  const [detail, setDetail] = useState({});
  const [spinning, setSpinning] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [showJs, setShowJs] = useState(false);

  const layout = {
    labelCol: {
      span: 8,
      style: { textAlign: "right", whiteSpace: "normal" },
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    const orgArr = [];
    orgs?.map((item) => {
      orgArr.push({
        label: item.name,
        value: item.code,
        id: item.id,
      });
    });
    setOrgs(orgArr);
    if (type === "edit" || type === "see" || type === "check") {
      axios.get(API.getZntSjDetail + `?id=${selectedRow?.id}`).then((res) => {
        const data = res?.data?.result?.data;

        if (data?.type === "Hiagent") {
          setShowUrl(false);
          setShowApi(true);
          setShowJrdz(false);
          setShowOpen(false);

          if (data?.thirdAgentSummary === 0) {
            setCanEdit(true);
          } else {
            setCanEdit(false);
          }
        } else if (data?.type === "Dify") {
          setShowUrl(true);
          setShowApi(true);
          setShowJrdz(false);
          setShowOpen(false);
        } else if (data?.type === "外链") {
          setShowJrdz(true);
          setShowOpen(true);
          setShowApi(false);
          setShowUrl(false);
        }
        if (data?.iconKey) {
          setFileList([
            {
              uid: data.iconKey,
              status: "done",
              url: data.iconPath,
              uuid: data.iconKey,
            },
          ]);
        }

        setOrgId(data?.orgId);
        setOrgName(data?.orgName);
        setDataSource(data?.questions);
        setWebData(data?.websites);
        setDetail(data);
        setSpinning(false);
      });
    } else {
      setSpinning(false);
    }
  }, []);

  if (ref) {
    ref.current = {
      getValue: () => {
        return {
          ...formRef.current?.getFieldsValue(),
          orgId: orgId,
          orgName: orgName,
          iconKey: fileList?.[0]?.uid,
          iconPath: fileList?.[0]?.url,
        };
      },
      verify: async () => {
        try {
          return await formRef.current.validateFields();
        } catch {
          return Promise.reject();
        }
      },
    };
  }

  // 封装File转Base64的异步函数（复用性更高）
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      // 读取文件为Base64 DataURL（核心API）
      reader.readAsDataURL(file);
      // 读取成功的回调
      reader.onload = () => resolve(reader.result); // result就是Base64字符串
      // 读取失败的回调
      reader.onerror = (err) => reject(err);
    });
  };

  return (
    <Spin spinning={spinning}>
      {!spinning ? (
        <Form
          style={{
            padding: "25px 0",
          }}
          className="znsqFormDetail"
          ref={formRef}
          initialValues={
            type === "add"
              ? {
                  userCode: userInfo?.code,
                  userName: userInfo?.name,
                  phone: userInfo?.phone,
                  email: userInfo?.email,
                  orgCode: orgs?.[0]?.code,
                }
              : { ...detail }
          }
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item {...layout} label="工号" name="userCode">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="姓名" name="userName">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="单位" name="orgCode">
                <Select
                  options={orgsData}
                  value={orgs?.[0]?.code}
                  onChange={(val, item) => {
                    setOrgName(item.label);
                    setOrgId(item.id);
                  }}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="联系方式" name="phone">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="邮箱"
                name="email"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label="名称"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "请填写名称",
                  },
                ]}
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="类型" name="type">
                <Select
                  options={[
                    {
                      label: "Hiagent",
                      value: "Hiagent",
                    },
                    {
                      label: "Dify",
                      value: "Dify",
                    },
                    {
                      label: "外链",
                      value: "外链",
                    },
                  ]}
                  disabled={type === "add" ? false : true}
                  onChange={(val) => {
                    console.log(val);
                    if (val === "Hiagent") {
                      setShowUrl(false);
                      setShowApi(true);
                      setShowJrdz(false);
                      setShowOpen(false);
                      setShowJs(true);
                    } else if (val === "Dify") {
                      setShowUrl(true);
                      setShowApi(true);
                      setShowJrdz(false);
                      setShowOpen(false);
                      setCanEdit(false);
                      setShowJs(false);
                      setCanEdit(true);
                    } else if (val === "外链") {
                      setShowJrdz(true);
                      setShowOpen(true);
                      setShowApi(false);
                      setShowUrl(false);
                      setCanEdit(false);
                      setShowJs(false);
                      setCanEdit(true);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {showUrl ? (
              <Col span={12}>
                <Form.Item {...layout} label="基础Url" name="url">
                  <Input disabled={type === "add" ? false : true} />
                </Form.Item>
              </Col>
            ) : null}
            {showJrdz ? (
              <Col span={12}>
                <Form.Item {...layout} label="接入地址" name="link">
                  <Input disabled={type === "add" ? false : true} />
                </Form.Item>
              </Col>
            ) : null}

            {shwoOpen ? (
              <Col span={12}>
                <Form.Item {...layout} label="打开方式" name="openType">
                  <Select
                    options={[
                      {
                        label: "内嵌",
                        value: "2",
                      },
                      {
                        label: "新窗口",
                        value: "1",
                      },
                    ]}
                    disabled={type === "add" ? false : true}
                  />
                </Form.Item>
              </Col>
            ) : null}

            <Col span={12}>
              <Form.Item {...layout} label="分类" name="category">
                <Select
                  options={zntTypes}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            {showJs ? (
              <Col span={12}>
                <Form.Item
                  labelCol={{
                    span: 8,
                  }}
                  label="第三方智能体介绍"
                  name="thirdAgentSummary"
                >
                  <Select
                    options={[
                      {
                        label: "不接入",
                        value: 0,
                      },
                      {
                        label: "HiAgent",
                        value: 1,
                      },
                    ]}
                    onChange={(val) => {
                      console.log(val);
                      if (val === 0) {
                        setCanEdit(true);
                      } else {
                        setCanEdit(false);
                        formRef.current?.setFieldsValue({
                          questions: [],
                        });
                        formRef.current?.setFieldsValue({
                          introduction: "",
                        });
                      }
                    }}
                    disabled={type === "add" ? false : true}
                  />
                </Form.Item>
              </Col>
            ) : null}
            {showApi ? (
              <Col span={24}>
                <Form.Item
                  labelCol={{
                    span: 4,
                  }}
                  label="API密钥"
                  name="apiKey"
                >
                  {type === "add" ? (
                    <Input disabled={type === "add" ? false : true} />
                  ) : (
                    <Input.Password disabled={type === "add" ? false : true} />
                  )}
                </Form.Item>
              </Col>
            ) : null}

            <Col span={12}>
              <Form.Item {...layout} label="发布范围" name="publishRange">
                <Radio.Group
                  options={[
                    {
                      label: "全部",
                      value: "1",
                    },
                    {
                      label: "指定部门",
                      value: "2",
                    },
                  ]}
                  disabled={type === "add" ? false : true}
                  onChange={(val) => {
                    if (val?.target?.value * 1 === 1) {
                      setShowDep(false);
                    } else {
                      setShowDep(true);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {showDep ? (
              <Col span={12}>
                <Form.Item
                  {...layout}
                  label="发布指定部门"
                  name="publishOrgCodes"
                >
                  <Select
                    allowClear
                    mode="multiple"
                    disabled={type === "add" ? false : true}
                    options={departments}
                  />
                </Form.Item>
              </Col>
            ) : null}

            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="图标"
                name="files"
              >
                <Upload
                  maxCount={1}
                  fileList={fileList}
                  onChange={() => {}}
                  listType="picture-card"
                  beforeUpload={() => {}}
                  onRemove={() => {
                    setFileList([]);
                  }}
                  disabled={type === "add" ? false : true}
                  customRequest={async (val) => {
                    const { file } = val;
                  

                    try {
                      const formData = new FormData();
                      const base64Str = await fileToBase64(file);

                      file.baseImg = base64Str;
                      formData.append("files", file);
                      let obj = {...file}
                      console.log(obj,file)
                      axios
                        .post(API.uploadFile, {
                          name:file?.name,
                          baseImg:file?.baseImg
                        }, {
                          headers: {
                            "Content-Type": "application/json",
                          },
                        })
                        .then((res) => {
                          const data = [res?.data?.result?.data || {}];
                          const arr = [];
                          data.map((item) => {
                            arr.push({
                              uid: item.fileKey,
                              name: item.filename,
                              status: "done",
                              url: item.previewUri,
                              uuid: item.fileKey,
                              size: item.fileSize,
                            });
                          });
                          setFileList([...arr]);
                        });
                    } catch {}
                  }}
                  accept=".jpg,.jpeg,.png"
                >
                  {fileList.length >= 1 ? undefined : (
                    <Button icon={<PlusOutlined />}>上传</Button>
                  )}
                </Upload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="介绍"
                name="introduction"
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 2,
                    maxRows: 3,
                  }}
                  disabled={type === "add" ? (canEdit ? false : true) : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="风险提示"
                name="riskTip"
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 2,
                    maxRows: 3,
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="提醒频次"
                name="riskTipFreq"
              >
                <Radio.Group
                  options={[
                    {
                      label: "不提醒",
                      value: "0",
                    },
                    {
                      label: "仅首次提醒",
                      value: "1",
                    },
                    {
                      label: "每次都提醒",
                      value: "2",
                    },
                  ]}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="热门问题"
                name="questions"
              >
                <EditableProTable
                  bordered
                  columns={
                    type == "add"
                      ? [
                          {
                            title: "名称",
                            dataIndex: "question",
                            editable: true,
                          },
                          {
                            title: "操作",
                            valueType: "option",
                            width: 200,
                            render: (text, record, _, action) => [
                              <a
                                key="editable"
                                onClick={() => {
                                  action?.startEditable?.(record.id, record);
                                }}
                              >
                                编辑
                              </a>,
                              <a
                                key="delete"
                                onClick={() => {
                                  console.log(record, "行数据");
                                  const tableDataSource =
                                    formRef.current?.getFieldValue("questions");
                                  console.log(tableDataSource, formRef.current);
                                  formRef.current?.setFieldsValue({
                                    questions: tableDataSource.filter(
                                      (item) => item.id !== record.id
                                    ),
                                  });
                                }}
                              >
                                删除
                              </a>,
                            ],
                          },
                        ]
                      : [
                          {
                            title: "名称",
                            dataIndex: "question",
                            editable: true,
                          },
                        ]
                  }
                  dataSource={dataSource}
                  showHeader={false}
                  rowKey={"id"}
                  maxLength={20}
                  recordCreatorProps={
                    type === "add"
                      ? canEdit
                        ? {
                            record: () => {
                              return {
                                id: uuidv4(),
                                question: "",
                              };
                            },
                            creatorButtonProps: {
                              disabled: dataSource.length >= 20, // 行数≥20时禁用新增
                            },
                            creatorButtonText: "新增行", // 新增按钮文字（可选）
                          }
                        : false
                      : false
                  }
                  onChange={(nextData) => {
                    console.log(nextData);
                    setDataSource(nextData);
                  }}
                  editable={{
                    type: "multiple",
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="常见网站导航"
                name="websites"
              >
                <EditableProTable
                  bordered
                  columns={
                    type === "add"
                      ? [
                          {
                            title: "名称",
                            dataIndex: "name",
                          },
                          {
                            title: "url",
                            dataIndex: "url",
                          },
                          {
                            title: "操作",
                            valueType: "option",
                            width: 200,
                            render: (text, record, _, action) => [
                              <a
                                key="editable"
                                onClick={() => {
                                  action?.startEditable?.(record.id, record);
                                }}
                              >
                                编辑
                              </a>,
                              <a
                                key="delete"
                                onClick={() => {
                                  console.log(record, "行数据");
                                  const tableDataSource =
                                    formRef.current?.getFieldValue("websites");
                                  console.log(tableDataSource, formRef.current);
                                  formRef.current?.setFieldsValue({
                                    websites: tableDataSource.filter(
                                      (item) => item.id !== record.id
                                    ),
                                  });
                                }}
                              >
                                删除
                              </a>,
                            ],
                          },
                        ]
                      : [
                          {
                            title: "名称",
                            dataIndex: "name",
                          },
                          {
                            title: "url",
                            dataIndex: "url",
                          },
                        ]
                  }
                  dataSource={webData}
                  showHeader={false}
                  rowKey={"id"}
                  maxLength={20}
                  recordCreatorProps={
                    type === "add"
                      ? {
                          record: () => {
                            return {
                              id: uuidv4(),
                              name: "",
                              url: "",
                            };
                          },
                          creatorButtonProps: {
                            disabled: webData.length >= 20, // 行数≥20时禁用新增
                          },
                          creatorButtonText: "新增行", // 新增按钮文字（可选）
                        }
                      : false
                  }
                  onChange={(nextData) => {
                    console.log(nextData);
                    setDataSource(nextData);
                  }}
                  editable={{
                    type: "multiple",
                  }}
                />
              </Form.Item>
            </Col>

            {type === "check" || type === "see" ? (
              <>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核状态"
                    name="status"
                    rules={[
                      {
                        required: true,
                        message: "请选择审核状态",
                      },
                    ]}
                  >
                    <Radio.Group
                      options={[
                        {
                          label: "通过",
                          value: 2,
                        },
                        {
                          label: "驳回",
                          value: 3,
                        },
                      ]}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核意见"
                    name="auditOpinion"
                  >
                    <Input.TextArea
                      autoSize={{
                        minRows: 3,
                        maxRows: 6,
                      }}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : undefined}
          </Row>
        </Form>
      ) : undefined}
    </Spin>
  );
}

export default forwardRef(ZntsqFormDetail);
